<template>
  <a
    class="newsletter-teaser footer-newsletter"
    :class="{'footer-newsletter__simple': !newsletterContent.image}"
    :href="newsletterContent.link ? newsletterContent.link.url : null"
    :target="newsletterContent.link && newsletterContent.link.openLinkInNewWindow ? '_blank' : null"
    :title="newsletterContent.image ? newsletterContent.image.title : null"
  >
    <div
      v-if="newsletterContent.image"
      class="footer-newsletter__image"
      :class="newsletterContent.imageBgColor ? newsletterContent.imageBgColor : null"
    >
      <img
        class="footer-newsletter__image--img"
        :src="newsletterContent.image.src"
        :alt="newsletterContent.image.alt"
        :title="newsletterContent.image.title"
        :width="newsletterContent.image.width === 0 ? '100' : newsletterContent.image.width"
        :height="newsletterContent.image.height === 0 ? '100' : newsletterContent.image.height"
        loading="lazy"
      >
    </div>

    <div
      class="footer-newsletter__content"
      :class="[
        newsletterContent.textColor ? newsletterContent.textColor : null,
        newsletterContent.textBgColor ? newsletterContent.textBgColor : null
      ]"
    >
      <div class="footer-newsletter__content--text">
        <div
          v-if="newsletterContent.headline"
          class="footer-newsletter__headline"
          v-html="newsletterContent.headline"
        />
        <div
          v-if="newsletterContent.text"
          class="footer-newsletter__info"
          :class="[
            newsletterContent.sublineColor ? newsletterContent.sublineColor : null,
          ]"
          v-html="newsletterContent.text"
        />
      </div>
      <div class="footer-newsletter__content--button">
        <button
          v-if="newsletterContent.button"
          class="footer-newsletter__button"
          :class="[
            newsletterContent.buttonBgColor ? newsletterContent.buttonBgColor : 'button button--alt',
            newsletterContent.buttonTextColor ? newsletterContent.buttonTextColor : null
          ]"
        >
          {{ newsletterContent.button }}
        </button>
      </div>
    </div>
  </a>
</template>

<script>

  export default {
    props: {
      newsletterContent: Object
    },
    data() {
      return {};
    },
  };

</script>
